/* eslint-disable jsx-a11y/alt-text */
import { Grid, Box, Typography, Table, TableBody } from '@material-ui/core';
import React from 'react';
import { currencyFormatter } from '../Shared/colorFormat';

export class SalaryListPrintNew extends React.PureComponent<any, any> {
  componentDidMount() {
    // Add body class when component mounts
    document.body.classList.add('salary-print-landscape');
  }

  componentWillUnmount() {
    // Remove body class when component unmounts
    document.body.classList.remove('salary-print-landscape');
  }

  renderHeader = (company: any) => (
    <Grid item xs={12} style={{ marginBottom: 10 }}>
      {company?.header ? (
        <img
          src={company?.header}
          alt={company?.name}
          height="40"
          width="auto"
          style={{
            objectFit: 'contain',
            display: 'block',
            margin: '0 auto',
          }}
        />
      ) : (
        <Typography
          variant="h5"
          style={{ textAlign: 'center', fontWeight: 'bold' }}
        >
          {company?.name || ''}
        </Typography>
      )}
    </Grid>
  );

  renderTitle = (printData: any) => {
    const { isRTL, start } = printData;
    const monthName = isRTL
      ? new Date(start).toLocaleString('ar-QA', { month: 'long' })
      : new Date(start).toLocaleString('en-US', { month: 'long' });
    const year = new Date(start).getFullYear();

    return (
      <Grid item xs={12} style={{ marginBottom: 10 }}>
        <Grid container spacing={0}>
          <Grid item xs={12} style={{ marginBottom: 8 }}>
            <Typography style={{ textAlign: 'center' }} variant="h4">
              {isRTL ? 'كشف رواتب' : 'Salary Statement'}
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 5 }}>
            <Typography style={{ textAlign: 'center' }} variant="h6">
              {isRTL
                ? `شهر ${monthName} سنة ${year}`
                : `Month ${monthName} ${year}`}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  renderTableHeader = (isRTL: boolean) => {
    return (
      <thead>
        <tr
          style={{
            fontSize: 11,
            fontWeight: 'bold',
            backgroundColor: '#2c3e50',
          }}
        >
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL ? 'م' : '#'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL ? 'الاسم' : 'Name'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL ? 'المسمى الوظيفي' : 'Job Title'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL ? 'المرتب الأساسي' : 'Basic Salary'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL ? 'بدل غداء' : 'Lunch Allowance'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL ? 'المكافآت' : 'Bonuses'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL ? 'الاضافي' : 'Overtime'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL ? 'نسبة مبيعات المندوبين' : 'Sales Commission %'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL
              ? 'المبلغ الخاضع لنسبة المبيعات'
              : 'Amount Subject to Sales %'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL ? 'اجمالي مبيعات المندوبين' : 'Total Sales Rep'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
              backgroundColor: '#1b5e20',
            }}
          >
            {isRTL ? 'عمولة المبيعات' : 'Sales Commission'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL ? 'الغياب' : 'Absence'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL ? 'عدد ايام الغياب' : 'Absence Days'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL ? 'قيمة الغياب' : 'Absence Value'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL ? 'السلف المدفوعة' : 'Advance Paid'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL ? 'السلف المقبوضة' : 'Advance Received'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL ? 'صافي خصم السلف' : 'Net Advance Deduction'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL ? 'الخصم' : 'Discount'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL ? 'اجمالي المستقطع' : 'Total Deductions'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {isRTL ? 'اجمالي المستحق' : 'Total Due'}
          </th>
          <th
            style={{
              border: '1px solid #1a252f',
              padding: '8px',
              textAlign: 'center',
              fontWeight: 'bold',
              backgroundColor: '#28a745',
            }}
          >
            {isRTL ? 'صافي الراتب' : 'Net Salary'}
          </th>
        </tr>
      </thead>
    );
  };

  renderTableRow = (item: any, index: number, isRTL: any) => {
    // Calculate values - some may be missing from current data structure
    const basicSalary = item?.basicSalary || 0;
    const lunchAllowance = item?.extraSalary || 0;
    const bonuses = item?.bonos || 0;
    const overtime = item?.overtime || 0;
    const salesCommissionPercent = item?.salesCommissionPercent || 0;
    const amountSubjectToSales = item?.amountSubjectToSales || 0;
    const totalContractsSales = item?.totalContractsSales || 0;
    const salesCommission = item?.salesCommission || 0;
    const absenceDays = item?.absenceDays || 0;
    const absenceValue = item?.absenceValue || 0;
    const advancePaid = item?.advancePaid || 0;
    const advanceReceived = item?.advanceReceived || 0;
    const advancesAndDeductions = item?.advancesAndDeductions || 0;
    const discount = item?.deduction || 0;

    // Calculate totals
    const totalDeductions = discount + advancesAndDeductions + absenceValue;
    const totalDue =
      basicSalary + lunchAllowance + bonuses + overtime + salesCommission;
    const netSalary = totalDue - totalDeductions;

    const rowBackgroundColor = index % 2 === 0 ? '#f8f9fa' : '#ffffff';

    return (
      <tr style={{ fontSize: 9, backgroundColor: rowBackgroundColor }}>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'center',
            fontWeight: 'bold',
          }}
        >
          {index + 1}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'center',
          }}
        >
          {isRTL ? item?.employeeNameAr : item?.employeeName}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'center',
          }}
        >
          {isRTL ? item?.jobTitleAr : item?.jobTitle || ''}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'right',
          }}
        >
          {currencyFormatter({ value: basicSalary })}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'right',
          }}
        >
          {currencyFormatter({ value: lunchAllowance })}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'right',
          }}
        >
          {currencyFormatter({ value: bonuses })}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'right',
          }}
        >
          {currencyFormatter({ value: overtime })}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'center',
          }}
        >
          {salesCommissionPercent ? `${salesCommissionPercent}%` : ''}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'right',
          }}
        >
          {currencyFormatter({ value: amountSubjectToSales })}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'right',
          }}
        >
          {currencyFormatter({ value: totalContractsSales })}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'right',
            backgroundColor: '#e8f5e9',
          }}
        >
          {currencyFormatter({ value: salesCommission })}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'center',
            backgroundColor: '#fff3cd',
          }}
        >
          {isRTL ? 'الغياب' : 'Absence'}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'center',
            backgroundColor: '#fff3cd',
          }}
        >
          {absenceDays || ''}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'right',
            backgroundColor: '#fff3cd',
          }}
        >
          {currencyFormatter({ value: absenceValue })}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'right',
            backgroundColor: '#ffebee',
          }}
        >
          {currencyFormatter({ value: advancePaid })}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'right',
            backgroundColor: '#ffebee',
          }}
        >
          {currencyFormatter({ value: advanceReceived })}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'right',
            backgroundColor: '#ffebee',
          }}
        >
          {currencyFormatter({ value: advancesAndDeductions })}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'right',
            backgroundColor: '#ffebee',
          }}
        >
          {currencyFormatter({ value: discount })}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'right',
            backgroundColor: '#ffebee',
          }}
        >
          {currencyFormatter({ value: totalDeductions })}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'right',
            backgroundColor: '#d1ecf1',
          }}
        >
          {currencyFormatter({ value: totalDue })}
        </td>
        <td
          style={{
            border: '1px solid #dee2e6',
            padding: '6px',
            textAlign: 'right',
            fontWeight: 'bold',
            backgroundColor: '#28a745',
            color: 'white',
          }}
        >
          {currencyFormatter({ value: netSalary })}
        </td>
      </tr>
    );
  };

  renderTotalsRow = (printData: any) => {
    const { rows, isRTL } = printData;

    // Calculate totals
    let totalBasicSalary = 0;
    let totalLunchAllowance = 0;
    let totalBonuses = 0;
    let totalOvertime = 0;
    let totalSalesRepAll = 0;
    let totalSalesCommission = 0;
    let totalAbsenceValue = 0;
    let totalAdvancePaid = 0;
    let totalAdvanceReceived = 0;
    let totalAdvancesAndDeductions = 0;
    let totalDiscount = 0;

    rows?.forEach((item: any) => {
      totalBasicSalary += item?.basicSalary || 0;
      totalLunchAllowance += item?.extraSalary || 0;
      totalBonuses += item?.bonos || 0;
      totalOvertime += item?.overtime || 0;
      totalSalesRepAll += item?.totalContractsSales || 0;
      totalSalesCommission += item?.salesCommission || 0;
      totalAbsenceValue += item?.absenceValue || 0;
      totalAdvancePaid += item?.advancePaid || 0;
      totalAdvanceReceived += item?.advanceReceived || 0;
      totalAdvancesAndDeductions += item?.advancesAndDeductions || 0;
      totalDiscount += item?.deduction || 0;
    });

    const totalDeductions =
      totalDiscount + totalAdvancesAndDeductions + totalAbsenceValue;
    const totalDue =
      totalBasicSalary +
      totalLunchAllowance +
      totalBonuses +
      totalOvertime +
      totalSalesCommission;
    const totalNetSalary = totalDue - totalDeductions;

    return (
      <tr
        style={{
          fontSize: 11,
          fontWeight: 'bold',
          backgroundColor: '#e8f5e8',
          border: '2px solid #1a252f',
        }}
      >
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'center',
            color: '#1a252f',
          }}
          colSpan={3}
        >
          {isRTL ? 'المجموع' : 'Total'}
        </td>
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'right',
            color: '#1a252f',
          }}
        >
          {currencyFormatter({ value: totalBasicSalary })}
        </td>
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'right',
            color: '#1a252f',
          }}
        >
          {currencyFormatter({ value: totalLunchAllowance })}
        </td>
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'right',
            color: '#1a252f',
          }}
        >
          {currencyFormatter({ value: totalBonuses })}
        </td>
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'right',
            color: '#1a252f',
          }}
        >
          {currencyFormatter({ value: totalOvertime })}
        </td>
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'center',
            color: '#1a252f',
          }}
        ></td>
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'right',
            color: '#1a252f',
          }}
        ></td>
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'right',
            color: '#1a252f',
          }}
        >
          {currencyFormatter({ value: totalSalesRepAll })}
        </td>
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'right',
            color: '#1a252f',
            backgroundColor: '#e8f5e9',
          }}
        >
          {currencyFormatter({ value: totalSalesCommission })}
        </td>
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'center',
            color: '#1a252f',
            backgroundColor: '#fff3cd',
          }}
        ></td>
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'center',
            color: '#1a252f',
            backgroundColor: '#fff3cd',
          }}
        ></td>
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'right',
            color: '#1a252f',
            backgroundColor: '#fff3cd',
          }}
        >
          {currencyFormatter({ value: totalAbsenceValue })}
        </td>
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'right',
            color: '#1a252f',
            backgroundColor: '#ffebee',
          }}
        >
          {currencyFormatter({ value: totalAdvancePaid })}
        </td>
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'right',
            color: '#1a252f',
            backgroundColor: '#ffebee',
          }}
        >
          {currencyFormatter({ value: totalAdvanceReceived })}
        </td>
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'right',
            color: '#1a252f',
            backgroundColor: '#ffebee',
          }}
        >
          {currencyFormatter({ value: totalAdvancesAndDeductions })}
        </td>
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'right',
            color: '#1a252f',
            backgroundColor: '#ffebee',
          }}
        >
          {currencyFormatter({ value: totalDiscount })}
        </td>
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'right',
            color: '#1a252f',
            backgroundColor: '#ffebee',
          }}
        >
          {currencyFormatter({ value: totalDeductions })}
        </td>
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'right',
            color: '#1a252f',
            backgroundColor: '#d1ecf1',
          }}
        >
          {currencyFormatter({ value: totalDue })}
        </td>
        <td
          style={{
            border: '1px solid #1a252f',
            padding: '8px',
            textAlign: 'right',
            fontWeight: 'bold',
            color: 'white',
            backgroundColor: '#28a745',
          }}
        >
          {currencyFormatter({ value: totalNetSalary })}
        </td>
      </tr>
    );
  };

  renderSignatures = (isRTL: boolean) => {
    const managerSignatureUrl = '/manager.png';
    const accountantSignatureUrl =
      'https://res.cloudinary.com/jadwalio/image/upload/v1714217660/2_uklxvd.png';
    return (
      <Grid item xs={12} style={{ marginTop: 30 }}>
        <Grid container spacing={0}>
          <Grid item xs={6} style={{ textAlign: 'center' }}>
            <Box
              style={{
                border: '2px solid #1a252f',
                borderRadius: '8px',
                padding: '15px 20px',
                backgroundColor: '#f8f9fa',
                minHeight: '80px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Typography
                variant="h6"
                style={{
                  color: '#1a252f',
                  fontWeight: 'bold',
                  marginBottom: '10px',
                }}
              >
                {isRTL ? 'توقيع المدير' : 'Manager Signature'}
              </Typography>
              <img
                src={managerSignatureUrl}
                alt="Manager Signature"
                style={{
                  maxWidth: '180px',
                  maxHeight: '72px',
                  objectFit: 'contain',
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={6} style={{ textAlign: 'center' }}>
            <Box
              style={{
                border: '2px solid #1a252f',
                borderRadius: '8px',
                padding: '15px 20px',
                backgroundColor: '#f8f9fa',
                minHeight: '80px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Typography
                variant="h6"
                style={{
                  color: '#1a252f',
                  fontWeight: 'bold',
                  marginBottom: '10px',
                }}
              >
                {isRTL ? 'توقيع / المحاسب' : 'Accountant Signature'}
              </Typography>
              <img
                src={accountantSignatureUrl}
                alt="Accountant Signature"
                style={{
                  maxWidth: '180px',
                  maxHeight: '72px',
                  objectFit: 'contain',
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  render() {
    const { company, printData } = this.props;
    const { isRTL, rows } = printData;

    return (
      <div className="salary-landscape">
        <table className="report-container">
          <thead className="report-header">
            <tr>
              <th className="report-header-cell">
                <div className="header-info">{this.renderHeader(company)}</div>
              </th>
            </tr>
          </thead>
          <tbody className="report-content">
            <tr>
              <td className="report-content-cell">
                <div className="main">
                  <Box style={{ direction: isRTL ? 'rtl' : 'ltr' }}>
                    <Grid container spacing={0}>
                      <Grid item xs={12}>
                        <Box ml={2} mr={2}>
                          <Grid container spacing={0}>
                            {this.renderTitle(printData)}
                            <Grid item xs={12}>
                              <Table
                                size="small"
                                style={{ borderCollapse: 'collapse' }}
                              >
                                {this.renderTableHeader(isRTL)}
                                <TableBody>
                                  {rows?.map((item: any, index: number) =>
                                    this.renderTableRow(item, index, isRTL),
                                  )}
                                  {this.renderTotalsRow(printData)}
                                </TableBody>
                              </Table>
                            </Grid>
                            {this.renderSignatures(isRTL)}
                          </Grid>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot className="report-footer">
            <tr>
              <td className="report-footer-cell">
                <div className="footer-info">
                  <div className={'page-footer'}></div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }
}

export default SalaryListPrintNew;
